import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useState, useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styled from 'styled-components';
import cn from 'classnames';
import { SWIPER_EFFECT, SWIPER_PARALLAX } from '../../../constants/globalConstants.js';
import { A11y, Autoplay, EffectFade, Parallax } from 'swiper/modules';
import { Context } from '../../../global-state-context';
import styles from './Slider.style.js';
import SliderControls from './SliderControls.js';
import Img from '../../atoms/Img/Img.js';
import { BREAKPOINTS, MAX_BREAKPOINTS } from '../../../themes/breakpoints.js';
import 'swiper/css';
import StylesEffectFade from './StyleModules/StylesEffectFade.js';
import StylesParallax from './StyleModules/StylesParallax.js';
function Slider(_ref) {
  var _heroCarouselData$car, _heroCarouselData$car2;
  var children = _ref.children,
    className = _ref.className,
    isHero = _ref.isHero,
    heroCarouselData = _ref.heroCarouselData;
  var _useContext = useContext(Context),
    headerOverlay = _useContext.headerOverlay,
    siteBanner = _useContext.siteBanner,
    isNewSiteBanner = _useContext.isNewSiteBanner;
  var carouselOptions = heroCarouselData.carouselOptions,
    mobileHeroVariation = heroCarouselData.mobileHeroVariation;
  var _useState = useState(false),
    isSliding = _useState[0],
    setIsSliding = _useState[1];
  var modifiers = {
    'nva-slider--mobile-full': mobileHeroVariation === 'Full',
    'nva-slider--mobile-split': mobileHeroVariation === 'Split',
    'nva-slider--full-width u-full-width': carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.fullWidth,
    'nva-slider--header-overlay': headerOverlay && isHero,
    'nva-slider--site-banner': siteBanner && isHero,
    'nva-slider--old-banner': !isNewSiteBanner,
    'nva-slider--parallax-on-scroll': carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxOnScroll,
    'nva-slider--parallax-on-slide': SWIPER_PARALLAX.ENABLED === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType),
    'nva-slider--parallax-single-image': SWIPER_PARALLAX.ENABLED_SINGLE_IMAGE === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType)
  };
  var modules = [A11y, Autoplay];
  var options = {
    spaceBetween: 0,
    slidesPerView: 1,
    rewind: true,
    // If loop is used instead, it requires a fix for bg video re-rendering issues
    autoplay: {
      enabled: (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.autoplay) === false ? false : true,
      delay: heroCarouselData.timePerSlide || 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  };
  if (SWIPER_EFFECT.FADE.NAME === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.effect)) {
    modules.push(EffectFade);
    options.effect = SWIPER_EFFECT.FADE.LIBRARY_NAME;
  }
  if (SWIPER_EFFECT.SLIDE.NAME === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.effect)) {
    options.effect = SWIPER_EFFECT.SLIDE.LIBRARY_NAME;
  }
  if (SWIPER_PARALLAX.ENABLED === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType)) {
    modules.push(Parallax);
    options.parallax = true;
    options.speed = 1200;
  }
  if (SWIPER_PARALLAX.ENABLED_SINGLE_IMAGE === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType)) {
    modules.push(Parallax);
    options.parallax = true;
  }
  return __jsx("section", {
    className: cn('nva-slider', isHero && 'nva-slider--hero', 'nva-slider--controls-compact', _objectSpread({}, modifiers), className, isSliding && 'is-sliding')
  }, SWIPER_EFFECT.FADE.NAME === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.effect) && __jsx(StylesEffectFade, null), SWIPER_PARALLAX.ENABLED === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType) || SWIPER_PARALLAX.ENABLED_SINGLE_IMAGE === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType) && __jsx(StylesParallax, null), __jsx(Swiper, _extends({
    className: "nva-slider__swiper",
    a11y: {
      enabled: true
    }
  }, options, {
    modules: modules,
    watchSlidesProgress: true,
    onSlideChangeTransitionStart: function onSlideChangeTransitionStart() {
      return setIsSliding(true);
    },
    onSlideChangeTransitionEnd: function onSlideChangeTransitionEnd() {
      return setIsSliding(false);
    }
  }), SWIPER_PARALLAX.ENABLED_SINGLE_IMAGE === (carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.parallaxType) && __jsx(Slider.ParallaxSingleImg, {
    firstSlide: heroCarouselData === null || heroCarouselData === void 0 ? void 0 : (_heroCarouselData$car = heroCarouselData.cardsCollection) === null || _heroCarouselData$car === void 0 ? void 0 : (_heroCarouselData$car2 = _heroCarouselData$car.items) === null || _heroCarouselData$car2 === void 0 ? void 0 : _heroCarouselData$car2[0],
    mobileHeroVariation: mobileHeroVariation
  }), children, heroCarouselData.cardsCollection.items.length > 1 && __jsx(SliderControls, {
    heroCarouselData: heroCarouselData
  })));
}
Slider.Slide = function Slide(_ref2) {
  var children = _ref2.children,
    index = _ref2.index;
  return __jsx(SwiperSlide, {
    className: cn('nva-slider__slide', "nva-slider__slide--".concat(index + 1))
  }, children);
};
// https://github.com/nolimits4web/swiper/issues/4413#issuecomment-1021387492
Slider.Slide.displayName = 'SwiperSlide';
Slider.ParallaxSingleImg = function ParallaxSingleImg(_ref3) {
  var _firstSlide$backgroun, _firstSlide$backgroun2, _firstSlide$backgroun3, _firstSlide$backgroun4, _firstSlide$backgroun5, _firstSlide$backgroun6, _firstSlide$backgroun7, _firstSlide$backgroun8;
  var firstSlide = _ref3.firstSlide,
    mobileHeroVariation = _ref3.mobileHeroVariation;
  var _useContext2 = useContext(Context),
    blurredPageHeroBgImg = _useContext2.blurredPageHeroBgImg;

  // TODO: this is duplicated from SliderCard.js
  var sourcesSettings = {
    '3xl': {
      '1x': {
        h: 567,
        w: 1600
      },
      '2x': {
        h: 1134,
        w: 3200
      }
    },
    xl: {
      '1x': {
        h: 567,
        w: 1485
      },
      '2x': {
        h: 1134,
        w: 2970
      }
    },
    lg: {
      '1x': {
        h: 567,
        w: 1195
      },
      '2x': {
        h: 1134,
        w: 2390
      }
    },
    md: {
      '1x': {
        h: 420,
        w: 800
      },
      '2x': {
        h: 840,
        w: 1600
      }
    },
    xs: {
      '1x': {
        h: 250,
        w: 414
      },
      '2x': {
        h: 500,
        w: 828
      }
    }
  };
  if (mobileHeroVariation === 'Full') {
    sourcesSettings.md = {
      '1x': {
        h: 468,
        w: 800
      },
      '2x': {
        h: 936,
        w: 1600
      }
    };
    sourcesSettings.xs = {
      '1x': {
        h: 468,
        w: 414
      },
      '2x': {
        h: 936,
        w: 828
      }
    };
  }
  return __jsx("div", {
    className: "nva-slider__single-parallax-bg"
  }, __jsx(Img, {
    src: (firstSlide === null || firstSlide === void 0 ? void 0 : (_firstSlide$backgroun = firstSlide.backgroundImage) === null || _firstSlide$backgroun === void 0 ? void 0 : (_firstSlide$backgroun2 = _firstSlide$backgroun.image) === null || _firstSlide$backgroun2 === void 0 ? void 0 : _firstSlide$backgroun2.url) || (firstSlide === null || firstSlide === void 0 ? void 0 : (_firstSlide$backgroun3 = firstSlide.backgroundImage) === null || _firstSlide$backgroun3 === void 0 ? void 0 : (_firstSlide$backgroun4 = _firstSlide$backgroun3.mobileImage) === null || _firstSlide$backgroun4 === void 0 ? void 0 : _firstSlide$backgroun4.url),
    mobileSrc: (firstSlide === null || firstSlide === void 0 ? void 0 : (_firstSlide$backgroun5 = firstSlide.backgroundImage) === null || _firstSlide$backgroun5 === void 0 ? void 0 : (_firstSlide$backgroun6 = _firstSlide$backgroun5.mobileImage) === null || _firstSlide$backgroun6 === void 0 ? void 0 : _firstSlide$backgroun6.url) || (firstSlide === null || firstSlide === void 0 ? void 0 : (_firstSlide$backgroun7 = firstSlide.backgroundImage) === null || _firstSlide$backgroun7 === void 0 ? void 0 : (_firstSlide$backgroun8 = _firstSlide$backgroun7.image) === null || _firstSlide$backgroun8 === void 0 ? void 0 : _firstSlide$backgroun8.url),
    sourcesSettings: sourcesSettings,
    sizes: "(max-width: ".concat(MAX_BREAKPOINTS['3xl'], ") 100vw, (min-width: ").concat(BREAKPOINTS['3xl'], ") 1600px"),
    fill: true,
    priority: true,
    blurDataURL: blurredPageHeroBgImg
  }));
};

// TODO: add prop types
// Slider.defaultProps = {
// };

// Slider.propTypes = {
//   className: PropTypes.string,
// };

export default styled(Slider).withConfig({
  componentId: "sc-1pe9sc3-0"
})(["", ";"], styles);